import React from "react";
import CreatePostLeftText from "./CreatePostLeftText";
import CreatePostRightText from "./CreatePostRightText";

const CreatePostTextSections = () => {
  const textSections = [
    {
      type: "left",
      heading: "Post Your Trade",
      text: "Tell people what you do."
    },
    {
      type: "right",
      heading: "Get the Call",
      text: "Customers reach out direct by message or phone."
    },
    {
      type: "left",
      heading: "Do the Job",
      text: "Turn up, get it done."
    },
    {
      type: "right",
      heading: "Get Paid",
      text: "No commission, no cuts. Payments direct with the client."
    }
  ];

  return (
    <div className="mt-10 sm:mt-20">
      {textSections.map((section, index) => {
        if (section.type === "left") {
          return (
            <CreatePostLeftText
              key={index}
              heading={section.heading}
              text={section.text}
            />
          );
        } else {
          return (
            <CreatePostRightText
              key={index}
              heading={section.heading}
              text={section.text}
            />
          );
        }
      })}
    </div>
  );
};

export default CreatePostTextSections;
